export const MODAL_FORM_FALLBACK_CLASS = 'modal-form';
export const MODAL_FORM_FALLBACK_NAME = 'modal-form';
